import React, { memo } from 'react'
import { graphql } from 'relay-runtime'
import { ChatMessage_Message$key } from '__generated__/ChatMessage_Message.graphql'
import ChatThreadItem from 'components/ChatThreadItem'
import { useSubscription } from 'hooks/relay'
import { useFragment } from 'react-relay'

interface IChatMessageProps {
  messageFragmentRef: ChatMessage_Message$key
}

function ChatMessage(props: IChatMessageProps) {
  const { messageFragmentRef } = props

  const message = useFragment(graphql`
    fragment ChatMessage_Message on ChatMessage
    {
      id
      label
      createdAt
      message
      
      ...ChatThreadItem_ChatMessage

      sender {
        ...ChatThreadItem_Contact
      }
    }
  `, messageFragmentRef)

  useSubscription({
    subscription: graphql`
      subscription ChatMessage_Subscription($chatMessageId: ID!) {
        chatMessageUpdated(chatMessageId: $chatMessageId) {
          chatMessage {
            message
          }
        }
      }
    `,
    variables: {
      chatMessageId: message?.id,
    },
  })

  if (!message) return null

  return (
    <ChatThreadItem
      contactFragmentRef={message.sender}
      message={message.message}
      label={message.label}
      createdAt={message.createdAt}
      chatMessageFragmentRef={message}
    />
  )
}

export default memo(ChatMessage)
